let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Q4SEd")).then(() => parcelRequire('lhCnN'));